export default "__VITE_ASSET__V_6yrKvW__"